export default __webpack_public_path__ + "static/media/imgTitleModal.54f04b5a.png";